import styled from 'styled-components';

export const CardContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  border: 1px solid #c8cdd8;
  border-radius: 6px;

  flex-direction: column;
  padding: 14px;

  &:first-child {
    border: 2px solid #000000;
  }
`;

export const InformationsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #eff2f7;
  width: 100%;
`;

export const CardHeader = styled.header`
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 700;
  color: #000000;
  padding-bottom: 7px;
`;

export const InformationsContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  gap: 8px;

  font-family: Montserrat;
  font-size: 14px;
  font-weight: 400;
  padding-bottom: 7px;
`;

export const InformationsContainerFooter = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 7px;
  gap: 30px;
`;

export const DealName = styled.span`
  font-weight: 700;
  font-size: 12px;
  color: #000000;
`;

export const DealDate = styled.span`
  font-weight: 600;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.5);
`;

export const InformationsItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

export const InformationTitle = styled.div`
  font-family: Montserrat;
  font-weight: 600;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.5);
`;

export const InformationValue = styled.div`
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  color: #26415e;
`;
